module.exports = __webpack_public_path__ + "static/img/4.a2bf615.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/14/zh/4.png
// module id = 24tJ
// module chunks = 0